export const DEFAULT_PROJECT_ID = 0 as const;
export const DEFAULT_PROJECT_ID_SLUG = String(DEFAULT_PROJECT_ID);
